import React from "react";
import { Helmet } from "react-helmet-async";

const CookiePolicyPage = () => {
  const policy = [
    {
      header: "1. Вступ",
      text: "Ця Політика використання файлів cookie пояснює, як веб-сайт 210polk.mil.gov.ua (далі – “Сайт”) використовує файли cookie та подібні технології для збору та обробки інформації про вас. Ми використовуємо файли cookie для забезпечення належної роботи Сайту та надання кращого користувацького досвіду.",
    },
    {
      header: "2. Що таке файли cookie?",
      text: "Файли cookie – це невеликі текстові файли, які зберігаються на вашому пристрої, коли ви відвідуєте веб-сайт. Вони використовуються для збору інформації про ваші вибори та налаштування, а також для збору даних для аналізу та покращення функціонування Сайту.",
    },
    {
      header: "3. Типи файлів cookie, які ми використовуємо",
      text: "Файли необхідні для роботи: Ці файли допомагають забезпечити правильну роботу Сайту та доступ до основних функцій. Файли аналітики: Ми використовуємо файли cookie для збору анонімних даних про використання Сайту, щоб розуміти, як користувачі взаємодіють з контентом та покращити його якість.",
    },
    {
      header: "4. Керування файлами cookie",
      text: "Ви маєте можливість керувати використанням файлів cookie через налаштування вашого веб-браузера. Ви можете вибрати блокування всіх файлів cookie або отримати попередження перед їх збереженням. Зверніть увагу, що вимкнення файлів cookie може призвести до обмеження доступу до деяких функцій Сайту.",
    },
    {
      header: "5. Відмова від відповідальності",
      text: "Ми не несемо відповідальність за файли cookie та технології третіх сторін, які можуть використовуватися на Сайті. Рекомендуємо переглядати політику конфіденційності та використання файлів cookie цих третіх сторін.",
    },
    {
      header: "6. Зміни в Політиці використання файлів cookie",
      text: "Ми можемо час від часу оновлювати цю Політику. Будь ласка, періодично переглядайте цей документ, щоб бути в курсі будь-яких змін.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>210 Окремий Штурмовий Полк | Політика файлів cookie</title>
        <meta name="description" content="Політика файлів cookie"/>
      </Helmet>
      <div style={styles.formWrapper}>
        <div style={{ ...styles.formWrapper, backgroundColor: "var(--olive)" }}>
          <div style={styles.headerContainer}>
            <h1 style={styles.formHeader}>Політика файлів cookie</h1>
          </div>
        </div>
        <div style={styles.formContainer}>
          {policy.map((item) => (
            <div style={styles.policyBlock}>
              <h2 style={styles.policyHeader}>{item.header}</h2>
              <p style={styles.policyText}>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

const styles: Record<string, React.CSSProperties> = {
  formWrapper: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    backgroundColor: "var(--white)",
    overflow: "hidden",
  },
  headerContainer: {
    display: "flex",
    flexDirection: "column",
    width: "var(--main-container-width)",
    margin: "0 auto",
    paddingTop: "4rem",
    paddingBottom: "2rem",
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    width: "var(--main-container-width)",
    margin: "0 auto",
    paddingTop: "2rem",
    paddingBottom: "4rem",
    gap: "2rem",
  },
  formHeader: {
    fontSize: "min(3rem,10vw)",
    fontWeight: "bold",
    color: "var(--dark-grey)",
    marginBottom: "1rem",
  },
  policyBlock: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
  },
  policyHeader: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: "var(--dark-grey)",
  },
  policyText: {
    fontSize: "1.2rem",
    color: "var(--dark-grey)",
  },
};

export default CookiePolicyPage;
